import { useAccountInfo } from './useAccountInfo';
import { useContract } from './useContract';

/* ***************************************************************************************************************
/ Combining hooks like this is not really a pattern we want to follow, so don't model any new hooks on this one. /
*************************************************************************************************************** */

export const useAccountAndContract = (accountId: string) => {
  const {
    accountInfo,
    error: accountInfoError,
    isLoading: isAccountInfoLoading,
    status: statusAccountInfo,
  } = useAccountInfo(accountId);
  const { loanNumber } = accountInfo || {};

  const {
    contract,
    error: contractError,
    isLoading: isContractLoading,
    status: statusContract,
  } = useContract({
    accountId,
    loanNumber,
  });

  const isLoading = isAccountInfoLoading || isContractLoading;
  const error = accountInfoError || contractError;

  // Including error/loading states for both the individual requests in addition to the combined results for convenience.
  return {
    accountInfo,
    accountInfoError,
    contract,
    contractError,
    error,
    isAccountInfoLoading,
    isContractLoading,
    isLoading,
    statusAccountInfo,
    statusContract,
  };
};
